import React from 'react';
import type { HandleFilterChanged } from '@/app/common/filters/core/filterComponentType.ts';
import type { FilterPill } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import {
  FilterGroupPill,
  type OnDynamicFilterUpdate,
} from '@/app/common/filters/surfaces/bar/pills/FilterGroupPill.tsx';
import type {
  CustomFilterGroupLabelCreators,
  CustomFilterMainCreators,
} from '@/app/common/filters/surfaces/forms/FilterGroupsComponents.tsx';

export type PillRowProps = {
  filterPills: FilterPill[];
  customFilterMainCreators: CustomFilterMainCreators;
  customFilterLabelCreators?: CustomFilterGroupLabelCreators;
  isLoading: boolean;
  handleFilterChanged: HandleFilterChanged;
  useModal?: boolean;
  onDynamicFilterUpdate?: OnDynamicFilterUpdate;
};

export const renderPillRow = ({
  filterPills,
  customFilterMainCreators,
  customFilterLabelCreators,
  isLoading,
  handleFilterChanged,
  useModal,
  onDynamicFilterUpdate,
}: PillRowProps) =>
  filterPills.map((filterPill) => {
    const { CustomPill } = filterPill;

    if (CustomPill) {
      return (
        <CustomPill
          filterPill={filterPill}
          customFilterMainCreators={customFilterMainCreators}
          isLoading={isLoading}
          handleFilterChanged={handleFilterChanged}
          useModal={useModal}
          key={filterPill.key ?? filterPill.id}
        />
      );
    }

    return (
      <FilterGroupPill
        filterPill={filterPill}
        customFilterMainCreators={customFilterMainCreators}
        customFilterLabelCreators={customFilterLabelCreators}
        isLoading={isLoading}
        handleFilterChanged={handleFilterChanged}
        useModal={useModal}
        onDynamicFilterUpdate={onDynamicFilterUpdate}
        key={filterPill.key ?? filterPill.id}
      />
    );
  });
